import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import LocaleStrings from "Languages";
import { DATE_FORMAT, itemCount, converDateIntoLocalDate } from "Constants";
import NoContent, { NO_BILLING } from "NoContent";
import Pagination from "react-js-pagination";
import { fetchclientbillinghistory } from "AccountSettingsAction";
// import ExportBailingExcelBtn from "./downloadbillingcsv.js";
import BillinghistoryListitem from "./biilinghistoryitem-list";
var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class BillinghistoryTable extends Component {
 
  constructor(props) {
    super(props);
    
    this.state = {
      loading: true,
      desc: LocaleStrings.settings_billing_details_preparing_list,
      loader: false,
      pageNumber: 1,
      activeLoader: false,
      showPicker: false
    };
  }

  componentDidMount() {
    let {clientdataforbilling} = this.props;
    let clientid= null;
    if(clientdataforbilling && clientdataforbilling.length > 0){
      clientid = clientdataforbilling[0].clientid;
    }
    // For Billing Info Table LIST
    if(clientid != null){
       this.props.fetchclientbillinghistory(
      this.props.session,
      0,
      clientid,
      (CallBackResponse) => {
        this.setState({ loading: false });
      }
    );
    }
   
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Sponsors Insights menu divs
    callFunction = () => {
      this.paginationCallback(this.state.pageNumber);
    };

    paginationCallback = (pageNumber) => {
      let {clientdataforbilling} = this.props;
      let clientid= null;
      if(clientdataforbilling && clientdataforbilling.length > 0){
        clientid = clientdataforbilling[0].clientid;
      }
      this.props.fetchclientbillinghistory(
        this.props.session,
        pageNumber,
        clientid,
        (CallBackResponse) => {
          this.setState({ loading: false });
        }
      );

      this.setState({ ...this.state, pageNumber });
    };

    renderClientHistorydatalist() {
      let pageDataLength = this.props.client_historydata.data.length;

      let { pageNumber } = this.state;

      return _.map(this.props.client_historydata.data, (values, index) => {
        return (
          <BillinghistoryListitem
            key={index}
            values={values}
            position={index}
            pagination={this.paginationCallback}
            pageDataLength={pageDataLength}
            currentPage={pageNumber}
          />
        );
      });
    }

  render() {
    var { session, deviceSize, client_historydata,clientdataforbilling } = this.props;
    
    return (
      <div className="panel noborder-panel">
        <div className="clearfix" />
        {/* Header */}
        <div className="sticky" style={{ borderTop: '1px solid #fafafa' }}>
        <div className="custom-text1-primary-medium " style={{paddingLeft:'33px',fontSize:'20px'}}>
                {LocaleStrings.accountsetting_billing_details_paymenthistory}
              </div>
          <br />
        </div>
        <div>
          {/* Table */}
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
            {client_historydata && client_historydata.count > 0 ? (
              <div className={this.state.activeLoader ? "user_main_div" : ""}>
              <div
                style={{padding:'26px'}}
                >
                <div className="">
                  <table className="table">
                    <thead>
                      <tr>
                        <th align="center">
                          {LocaleStrings.accountsetting_billing_details_table_th1}
                        </th>
                        <th align="center">
                          {LocaleStrings.accountsetting_billing_details_table_th2}
                        </th>
                        <th align="center">
                          {LocaleStrings.accountsetting_billing_details_table_th4}
                        </th>
                        <th align="center">
                          {LocaleStrings.accountsetting_billing_details_table_th5}
                        </th>
                        <th align="center">
                          {LocaleStrings.accountsetting_billing_details_table_th6}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="tbody-background">
                      {this.renderClientHistorydatalist()}
                    </tbody>
                  </table>
                  {this.props.client_historydata &&
                      this.props.client_historydata.count > itemCount ? (
                      <Pagination
                        activePage={this.state.pageNumber}
                        itemsCountPerPage={itemCount}
                        totalItemsCount={this.props.client_historydata.count}
                        pageRangeDisplayed={10}
                        onChange={this.paginationCallback}
                        style={{ float: "right" }}
                      />
                    ) : null}
                </div>
              </div>
            </div>
            ):(
              <NoContent contentType={NO_BILLING} />
            )}
            
            </>
          )}
        </div>
      </div>
    );
  }
}



function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    client_historydata: state.client_historydata,
    clientdataforbilling: state.clientdataforbilling
  };
}

export default connect(mapStateToProps, {
  fetchclientbillinghistory
})(BillinghistoryTable);
